<template>
  <div class="post-form-head">
    <div class="wrapper title-wrapper">
      <label>Назва</label>
      <input
        v-model="titleValue"
      ></input>
    </div>

    <div class="wrapper">
      <label>Головний текст</label>

      <div class="description-wrapper">
        <div
          v-if="!descriptionEditable"
          @click="startEditDescription"
        >
          <vue-markdown>{{ description }}</vue-markdown>&nbsp;
        </div>

        <textarea-autosize
          v-if="descriptionEditable"
          v-model="descriptionValue"
          @blur.native="descriptionEditable = false"
          placeholder="Опис"
          ref="description"
        ></textarea-autosize>
      </div>

    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import VueMarkdown from 'vue-markdown';

export default {
  name: 'PostFormHead',
  components: {
    VueMarkdown,
  },
  props: {
    title: {
      required: true,
    },
    description: {
      required: true,
    },
  },
  data() {
    return {
      titleEditable: false,
      descriptionEditable: false,
    };
  },
  computed: {
    titleValue: {
      get() {
        return this.title;
      },
      set(value) {
        this.$emit('update:title', value);
      },
    },
    descriptionValue: {
      get() {
        return this.description;
      },
      set(value) {
        this.$emit('update:description', value);
      },
    },
  },
  methods: {
    startEditDescription() {
      this.descriptionEditable = true;

      Vue.nextTick(() => {
        this.$refs.description.$el.focus();
      });
    },
  },
};
</script>

<style scoped>

.description-wrapper {
  outline: none;
  border: solid 1px rgba(0,0,0, .1);
  background: #fff;
  padding: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/PostFormHead.vue